import * as THREE from 'three';
import add_renderer from "./renderer";
import {Vector2, Vector3} from "three";
import store from "../store";
import {getPerspectivePoints} from "../fabric/libs/getPerspectivePoints";
import {getPerspectiveMatrix} from "../math/perspectiveTransform";
import {translatePoints} from "../math/getAreaCorrected";
import {findPlanePerspective} from "./findPlanePerspective";
import {getPerspectiveCamera} from "./getPerspectiveCamera";


export const get3dTexture = async function(planeID, img_src, boundingBox,scale, photoID) {
    this.starttime = new Date().getTime();
    this.scale = 10;
    this.planeWidth = 300000;
    this.planeHeight = 300000;
    this.planeTextureRepeatScale = 1/100;
    this.imageSize = await store.dispatch("active/GET_ACTIVE_IMG_SIZE");
    this.width = this.imageSize.width;
    this.height = this.imageSize.height;
    this.points = getPerspectivePoints(planeID, photoID);

    this.img_src = store.getters[`projectConfiguration/GENERATE_URL`](img_src);
    const activeProjectGUID = store.state.route.params.projectUUID;
    let perspectiveMatrix = await store.dispatch(
        `projectList/${activeProjectGUID}/photoList/${photoID}/planeList/${planeID}/GET_PERSPECTIVE_MATRIX`,{
            planeID: planeID,
            photoID: photoID,
        } );

    this.flatPoints = translatePoints(perspectiveMatrix, this.points);

    this.center = new Vector3(
        this.flatPoints[0].x + (this.flatPoints[1].x - this.flatPoints[0].x) / 2,
        this.width-(this.flatPoints[1].y + (this.flatPoints[2].y - this.flatPoints[1].y) / 2),
        0)

    this.scene = new THREE.Scene();
    const geometry = new THREE.PlaneBufferGeometry(this.planeWidth, this.planeHeight, 4, 4);
    let promise = new Promise((resolve) => {
        this.colormap = new THREE.TextureLoader().load(this.img_src, () => {
            resolve();
        })
    });
    await promise

    this.colormap.center.set(0.5, 0.5);
    this.colormap.wrapS = this.colormap.wrapT = THREE.RepeatWrapping;

    this.colormap.repeat.set(this.planeWidth*this.planeTextureRepeatScale/2.5, this.planeHeight*this.planeTextureRepeatScale);
    this.colormap.repeat_setting = {x: this.colormap.repeat.x, y: this.colormap.repeat.y};
    this.colormap.anisotropy = 16;
    this.colormap.needsUpdate = true;

    let material = new THREE.MeshBasicMaterial(
        {
            // color: 0xFF0000,
            side: THREE.DoubleSide,
            map: this.colormap
        }
    );

    this.grid = new THREE.Mesh(geometry, material);
    this.grid.position.set(this.center.x, this.center.y, 0);
    this.scene.add(this.grid);

    this.grid.updateMatrix();

    this.camera = await new getPerspectiveCamera(photoID, planeID);

    this.renderer = add_renderer(this.component, {
        width: this.width*scale,
        height: this.height*scale
    });
    this.renderer.render(this.scene, this.camera);

    if (this.component) {
        this.component.appendChild(this.renderer.domElement);
    }

    let temp_canvas = document.createElement("canvas");
    let temp_canvas_context = temp_canvas.getContext("2d");
    temp_canvas.width = (boundingBox.maxPoint.x - boundingBox.minPoint.x)*scale/window.devicePixelRatio;
    temp_canvas.height = (boundingBox.maxPoint.y - boundingBox.minPoint.y)*scale/window.devicePixelRatio;
    temp_canvas_context.drawImage(
        this.renderer.domElement,
        boundingBox.minPoint.x*scale/window.devicePixelRatio,
        boundingBox.minPoint.y*scale/window.devicePixelRatio,
        (boundingBox.maxPoint.x - boundingBox.minPoint.x)*scale/window.devicePixelRatio,
        (boundingBox.maxPoint.y - boundingBox.minPoint.y)*scale/window.devicePixelRatio,
        0,
        0,
        temp_canvas.width,
        temp_canvas.height
    );

    return temp_canvas.toDataURL("jpeg", 0.7);
}

